export default __webpack_public_path__ + "static/3box-1f59882561e9daf2b026e36989443330.png";